import { isTrialOptInCycle } from '../../../data/query/complimentary-trial-end.utils';
import { classifyTrialEndUsage, TrialEndUsageClass } from './classify-trial-end-usage';

export type ComplimentaryTrialEndedEligibilityInput = {
  isSettled: boolean;
  isCohortEnabled: boolean;
  isTrialEndEnabled: boolean;
  isAppleCompliantBuild: boolean;
  isExcluded: boolean;
  cycleStart: string | null | undefined;
  cycleEnd: string | null | undefined;
  consumed: string | null | undefined;
  displayLimit: string | null | undefined;
};

export type ComplimentaryTrialEndedUsageClass =
  | TrialEndUsageClass.High
  | TrialEndUsageClass.Moderate;

export const getComplimentaryTrialEndedUsageClass = ({
  isSettled,
  isCohortEnabled,
  isTrialEndEnabled,
  isAppleCompliantBuild,
  isExcluded,
  cycleStart,
  cycleEnd,
  consumed,
  displayLimit,
}: ComplimentaryTrialEndedEligibilityInput): ComplimentaryTrialEndedUsageClass | null => {
  if (
    !isSettled ||
    !isCohortEnabled ||
    !isTrialEndEnabled ||
    isAppleCompliantBuild ||
    isExcluded
  ) {
    return null;
  }
  if (consumed == null || displayLimit == null) return null;
  if (
    cycleStart == null ||
    cycleEnd == null ||
    isTrialOptInCycle({ cycle_start: cycleStart, cycle_end: cycleEnd })
  ) {
    return null;
  }

  const usageClass = classifyTrialEndUsage({ consumed, displayLimit });
  return usageClass === TrialEndUsageClass.Low ? null : usageClass;
};
